import { baseApi } from "common/redux/core/api.base";
import { MocService } from "../../services/moc.service";
import {
  LinkMocDocumentsRequest,
  LinkMocDocumentsResponse,
  MocMutationResponse,
  MocRequest,
  AssessmentStatusUpdateRequest,
  AssessmentStatusUpdateResponse,
  GenerateMocReportResponse,
  UpdateDecisionSummaryRequest,
  UpdateDecisionSummaryResponse
} from "../../models/moc.model";

const mocCommandsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createMoc: build.mutation<MocMutationResponse, MocRequest>({
      queryFn: (payload) => MocService.createMoc(payload)
    }),
    updateMoc: build.mutation<
      MocMutationResponse,
      { mocId: string; payload: MocRequest }
    >({
      queryFn: ({ mocId, payload }) => MocService.updateMoc(mocId, payload)
    }),
    addMocDocuments: build.mutation<
      LinkMocDocumentsResponse,
      { mocId: string; payload: LinkMocDocumentsRequest }
    >({
      queryFn: ({ mocId, payload }) =>
        MocService.addMocDocuments(mocId, payload)
    }),
    updateAssessmentStatus: build.mutation<
      AssessmentStatusUpdateResponse,
      AssessmentStatusUpdateRequest
    >({
      queryFn: ({ assessmentType, assessmentId, status }) =>
        MocService.updateAssessmentStatus(assessmentType, assessmentId, status)
    }),
    generateFinalMocReport: build.mutation<
      GenerateMocReportResponse,
      { mocId: string; file: Blob }
    >({
      queryFn: ({ mocId, file }) =>
        MocService.generateFinalMocReport(mocId, file)
    }),
    updateDecisionSummary: build.mutation<
      UpdateDecisionSummaryResponse,
      { mocId: string; payload: UpdateDecisionSummaryRequest }
    >({
      queryFn: ({ mocId, payload }) =>
        MocService.updateDecisionSummary(mocId, payload)
    })
  })
});

export const {
  useCreateMocMutation,
  useUpdateMocMutation,
  useAddMocDocumentsMutation,
  useUpdateAssessmentStatusMutation,
  useGenerateFinalMocReportMutation,
  useUpdateDecisionSummaryMutation
} = mocCommandsApi;
